<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
  color: {
    type: String,
    default: '#fff'
  }
});

const style = computed(() => {
  return {
    border: `1px solid ${props.color}`,
    'border-color': `${props.color} transparent transparent transparent`
  };
});
</script>

<template>
  <div class="app-loader lds-ring">
    <div :style="style"></div>
    <div :style="style"></div>
    <div :style="style"></div>
    <div :style="style"></div>
  </div>
</template>
